const AWS = require("aws-sdk");

export const getClientPolicy = async (governmentIdCard, dateOfBirth) => {
  const lambda = new AWS.Lambda({
    region: process.env.REACT_APP_AWS_REGION,
    accessKeyId: process.env.REACT_APP_AWS_ACCESS_KEY_ID,
    secretAccessKey: process.env.REACT_APP_AWS_SECRET_ACCESS_KEY,
  });
  return await new Promise((resolve, reject) => {
    lambda.invoke(
      {
        Qualifier: process.env.REACT_APP_VALIDATION_LAMBDA_FUNCTION_VERSION,
        FunctionName: process.env.REACT_APP_VALIDATION_LAMBDA_FUNCTION,
        Payload: JSON.stringify({
          headers: {
            governmentidcard: governmentIdCard,
            dob: dateOfBirth,
            productcode: process.env.REACT_APP_VALIDATION_PRODUCT_CODE,
            country: process.env.REACT_APP_VALIDATION_COUNTRY,
          },
        }),
      },
      async (err, res) => {
        if (err) {
          console.log(JSON.stringify(err));
          reject(err);
        }
        resolve(JSON.parse(res.Payload).body);
      }
    );
  });
};
